import { Signal } from '@angular/core';

export interface Explorer<T> {
  source: Signal<T[] | null | undefined>;
  result: Signal<T[] | null | undefined>;
}

export interface ExplorerAddon<T> {
  result: Signal<T[] | null | undefined>;
}

export type ExplorerAddonFactory<T, TAddon extends ExplorerAddon<T>> = (source: Signal<T[]>) => TAddon;
